import { colors } from '../colors.js';
import { radii } from '../radius.js';
import { space } from '../spacing.js';
import { zIndices } from '../z-index.js';
export const popover = {
    backgroundColor: colors.backgrounds.onGray,
    borderRadius: radii.x1_5,
    boxShadow: {
        alpha: 'x3',
        style: 'broad',
        color: 'secondary',
    },
    marginTop: space.x1,
    paddingRightLeft: space.x0,
    paddingTopBottom: space.x2,
    zIndex: zIndices.dropdown,
};
//# sourceMappingURL=popover.js.map